import React from 'react'
import NumberOfViews from './component'

type NumberOfViewsContainerProps = {
  artist: {
    fullName: string
    slug: string
  }
}

const NumberOfViewsContainer: React.FC<NumberOfViewsContainerProps> = ({
  artist: { fullName, slug },
}) => {
  const delta = fullName.length
  const delta2 = slug.length

  const baseNum = Number((delta * delta2).toString()[0] + Date.now().toString().slice(6, 9))
  const views = baseNum + delta + delta2

  return <NumberOfViews starName={fullName} numberOfViews={views} colorGlow="g-green-darker" />
}

export default NumberOfViewsContainer
